/*
 * Espejo de helpers/politicaClave.js de new-ws-claveunica. La app valida en
 * el navegador para dar feedback inmediato, pero esa validación es solo de
 * conveniencia: el cliente puede saltársela, así que el servicio vuelve a
 * validar antes de tocar o365 y Active Directory.
 *
 * Si se cambia una regla, hay que cambiarla en los dos repos.
 */

export const LARGO_MINIMO = 12;
export const LARGO_MAXIMO = 128;

// Desde este largo la clave se considera suficientemente robusta y no se exige
// mayúscula, dígito ni carácter especial.
export const LARGO_SIN_COMPLEJIDAD = 20;

export const CARACTERES_ESPECIALES = '-.$_#*,%&()?¿[{^~¨|><`';

// Cantidad de repeticiones consecutivas del mismo carácter que se rechaza.
export const REPETICIONES_CONSECUTIVAS_PROHIBIDAS = 4;

// El regex se arma a partir de CARACTERES_ESPECIALES para que la lista que se
// valida y la que se le muestra al usuario no puedan quedar desincronizadas.
const REGEX_ESPECIAL = new RegExp(`[${CARACTERES_ESPECIALES.replace(/[\\\]^-]/g, '\\$&')}]`);

const REGEX_MAYUSCULA = /[A-Z]/;
const REGEX_DIGITO = /[0-9]/;

// Se usa [\s\S] en vez de . para no dejar pasar repeticiones de saltos de línea.
const REGEX_REPETIDOS = new RegExp(
  `([\\s\\S])\\1{${REPETICIONES_CONSECUTIVAS_PROHIBIDAS - 1}}`
);

export const DESCRIPCION_POLITICA =
  `La nueva clave debe tener entre ${LARGO_MINIMO} y ${LARGO_MAXIMO} caracteres ` +
  `y no puede repetir ${REPETICIONES_CONSECUTIVAS_PROHIBIDAS} veces el mismo carácter de forma consecutiva. ` +
  `Con ${LARGO_SIN_COMPLEJIDAD} caracteres o más no se exige nada adicional. ` +
  `Si tiene menos de ${LARGO_SIN_COMPLEJIDAD}, debe incluir al menos una mayúscula, un número ` +
  `y uno de estos caracteres especiales: ${CARACTERES_ESPECIALES}`;

/**
 * Devuelve el motivo del rechazo, o null si la clave cumple.
 */
export default function validaPolitica(clave) {
  if (!clave) {
    return 'Debes ingresar una clave';
  }

  if (clave.length < LARGO_MINIMO) {
    return `La nueva clave debe tener un largo mínimo de ${LARGO_MINIMO} caracteres`;
  }

  if (clave.length > LARGO_MAXIMO) {
    return `La nueva clave debe tener un largo máximo de ${LARGO_MAXIMO} caracteres`;
  }

  if (clave.length < LARGO_SIN_COMPLEJIDAD) {
    if (!REGEX_MAYUSCULA.test(clave)) {
      return 'La nueva clave debe tener al menos una letra mayúscula';
    }
    if (!REGEX_DIGITO.test(clave)) {
      return 'La nueva clave debe tener al menos un número';
    }
    if (!REGEX_ESPECIAL.test(clave)) {
      return `La nueva clave debe tener al menos uno de estos caracteres especiales: ${CARACTERES_ESPECIALES}`;
    }
  }

  if (REGEX_REPETIDOS.test(clave)) {
    return `La nueva clave no puede contener ${REPETICIONES_CONSECUTIVAS_PROHIBIDAS} caracteres iguales consecutivos`;
  }

  return null;
}
